import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-color-preview-pop-up',
  templateUrl: './custom-color-preview-pop-up.component.html',
  styleUrls: ['./custom-color-preview-pop-up.component.scss'],
})
export class CustomColorPreviewPopUpComponent  implements OnInit {

  sidebarModule:any = [];
  moduleStyles: any ={};
  dashboardList: any=[]
  buttonColor:any;
  moduleNameColor:any
  subModuleButtonColor:any;
  buttonColorName:any;
  currentDate: any = new Date;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<CustomColorPreviewPopUpComponent>,private datePipe: DatePipe) { }

  ngOnInit() {
    this.currentDate = this.datePipe.transform(this.currentDate, "YYYY-MM"),
    this.moduleNameColor= this.data?.moduleNameColor,
    this.subModuleButtonColor= this.data?.subModuleButtonColor,
    this.buttonColorName= this.data?.buttonColorName,
    this.dashboardList = this.data?.selectedColor
    this.sidebarModule = [
      {
        moduleActiveIcon: '././assets/icon/pms.svg',
        moduleInactiveIcon: '././assets/icon/pms.svg',
        moduleName: 'PMS',
      },
      {
        moduleActiveIcon: '././assets/icon/elcm.svg',
        moduleInactiveIcon: '././assets/icon/elcm.svg',
        moduleName: 'ELCM',
      },
      {
        moduleActiveIcon: '././assets/icon/taskManagement.svg',
        moduleInactiveIcon: '././assets/icon/taskManagement.svg',
        moduleName: 'Task Management',
      },
    ]
    this.moduleStyles = {
      'background-color': this.moduleNameColor,
      'cursor': 'pointer',
      'border-top-right-radius': '50px',
      'border-bottom-right-radius': '50px',
      'width': '90%'
    };
  }
  tableHeadData:any=['Review Status','KRA','KPI','Lesser is Better','Milestone From','Milestone To']
  tableData:any=[
    {
      review:'Pending',
      kra:'My kra',
      kpi: 'My kpi',
      lesserisbetter: 'Yes',
      milestoneFrom: 'Jan',
      milestoneTo: 'Dec'
    },
    {
      review:'Pending',
      kra:'My kra',
      kpi: 'My kpi',
      lesserisbetter: 'Yes',
      milestoneFrom: 'Jan',
      milestoneTo: 'Dec'
    },
    {
      review:'Pending',
      kra:'My kra',
      kpi: 'My kpi',
      lesserisbetter: 'Yes',
      milestoneFrom: 'Jan',
      milestoneTo: 'Dec'
    },
    {
      review:'Pending',
      kra:'My kra',
      kpi: 'My kpi',
      lesserisbetter: 'Yes',
      milestoneFrom: 'Jan',
      milestoneTo: 'Dec'
    },
    {
      review:'Pending',
      kra:'My kra',
      kpi: 'My kpi',
      lesserisbetter: 'Yes',
      milestoneFrom: 'Jan',
      milestoneTo: 'Dec'
    },
  ]
}
